var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import styles from './Page.module.css';
export const Page = ({ 'aria-label': ariaLabel, 'data-testid': testId, isCurrentPage, onClick, pageNumber, }) => {
    return (_jsx("button", { "aria-current": isCurrentPage ? 'page' : undefined, "aria-label": ariaLabel, className: C(styles.Container, isCurrentPage && styles.Selected), "data-testid": testId, onClick: onClick, children: pageNumber }));
};
_react_refresh_temp_1 = Page;
$RefreshReg$(_react_refresh_temp_1, "Page");
